import * as React from 'react';
import s from './PageFooter.scss';
import { AcceptedPaymentMethods } from './AcceptedPaymentMethods';
import { MoneyBackGuarantee } from './MoneyBackGuarantee';
import { SSLSecurePayment } from './SSLSecurePayment';
import { withInjectedRootStore, RootStore } from 'providers';
import classNames from 'classnames';
import { SaleDisclaimer } from './SaleDisclaimer';
import { AfnicRecommended } from './AfnicRecommended';

export interface PageFooterProps {
  rootStore: RootStore;
  className?: string;
}

export const PageFooterAdvancedComp: React.FunctionComponent<
  PageFooterProps
> = ({ children, rootStore, className }) => {
  const {
    isChangePlan,
    isFranchPackagePicker,
    currentStep,
    isJapanesePackagePicker,
  } = rootStore.appStore;
  return (
    <div className={classNames(s.pageFooterContainer, className)}>
      <SaleDisclaimer>{children}</SaleDisclaimer>
      <div className={classNames(s.innerWrapper)}>
        <AcceptedPaymentMethods />
        {!isChangePlan && <MoneyBackGuarantee />}
        <SSLSecurePayment isJapanesePackagePicker={isJapanesePackagePicker} />
      </div>
      {isFranchPackagePicker && currentStep === 0 && <AfnicRecommended />}
    </div>
  );
};

export const PageFooter = withInjectedRootStore(PageFooterAdvancedComp);
